import { ESGImpactHexCodesMap } from 'shared/constants/ESGImpactHexCodesMap';

const { insignificant, veryLow, low, medium, high, veryHigh } = ESGImpactHexCodesMap;

export const getHexColorByImpact = (impactNumber, impactWeight) => {
  if (impactWeight) {
    if (impactNumber < 0.5) return veryLow;
    if (impactNumber <= 0.8) return low;
    if (impactNumber <= 1.2) return medium;
    if (impactNumber <= 3) return high;
    return veryHigh;
  }

  return insignificant;
};

export const getHexColorByScoreOverview = v => {
  if (v <= 2) return veryHigh;
  if (v <= 4) return high;
  if (v <= 6) return medium;
  if (v <= 8) return low;
  return veryLow;
};
